module.exports = __webpack_public_path__ + "static/media/tablet4.0043ffca.png";